export const rewardsActionTypes = {
  SET_REWARDS_DETAILS_LOADING: "SET_REWARDS_DETAILS_LOADING",
  SET_REWARDS_DETAILS_SUCCESS: "SET_REWARDS_DETAILS_SUCCESS",
  SET_REWARDS_DETAILS_ERROR: "SET_REWARDS_DETAILS_ERROR",
  REWARD_EVENT_LOADING: "REWARD_EVENT_LOADING",
  REWARD_EVENT_SUCCESS: "REWARD_EVENT_SUCCESS",
  REWARD_EVENT_ERROR: "REWARD_EVENT_ERROR",
  GAMIFICATION_DETAIL_LOADING: "GAMIFICATION_DETAIL_LOADING",
  GAMIFICATION_DETAIL_SUCCESS: "GAMIFICATION_DETAIL_SUCCESS",
  GAMIFICATION_DETAIL_ERROR: "GAMIFICATION_DETAIL_ERROR",
  REWARDS_DETAILS_LOADING: "REWARDS_DETAILS_LOADING",
  REWARDS_DETAILS_SUCCESS: "REWARDS_DETAILS_SUCCESS",
  REWARDS_DETAILS_ERROR: "REWARDS_DETAILS_ERROR",
  MM_DETAILS_LOADING: "MM_DETAILS_LOADING",
  MM_DETAILS_SUCCESS: "MM_DETAILS_SUCCESS",
  MM_DETAILS_ERROR: "MM_DETAILS_ERROR",
};
